<template>
  <div id="app">
    <notifications></notifications>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "POPSHIPPOP",
  props: ["title"],
  data() {
    return {
      color: "vue", //vue|blue|orange|green|red|primary
      userLogin: "",
      createdBy: "",
    };
  },
  watch: {
    title: {
      immediate: true,
      handler() {
        "POS";
      },
    },
  },
};
</script>
